/* =====================================================================
   Bridger Application Hub – ported 1:1 from NSA_Application_Hub_Cards.html.
   Scoped as a CSS Module so it cannot clash with the app's global
   Tailwind classes (.card, .badge, ...). Tokens live on .root, not :root.
   ===================================================================== */
.root{
  --seed-primary:#1F3864;
  --seed-secondary:#2E75B6;

  --primary-main:var(--seed-primary);
  --primary-light-2: color-mix(in srgb,var(--seed-primary) 2%, #fff);
  --primary-light-5: color-mix(in srgb,var(--seed-primary) 5%, #fff);
  --primary-light-10:color-mix(in srgb,var(--seed-primary) 10%,#fff);
  --primary-light-15:color-mix(in srgb,var(--seed-primary) 15%,#fff);
  --primary-light-30:color-mix(in srgb,var(--seed-primary) 30%,#fff);
  --primary-light-60:color-mix(in srgb,var(--seed-primary) 60%,#fff);
  --secondary-main:var(--seed-secondary);
  --secondary-light-10:color-mix(in srgb,var(--seed-secondary) 10%,#fff);

  --success-dark:#1B5E20;  --success-light-10:#E8F5E9;
  --warning-dark:#8A4B00;  --warning-light-10:#FFF4E0;
  --grey-700:#45505F;      --grey-500:#6B7584; --grey-300:#C9CFD8; --grey-100:#F1F3F6;
  --text-primary:#1A2233;  --text-secondary:#4A5568;
  --bg-default:var(--primary-light-2); --bg-paper:#fff;

  --sp-1:.5rem; --sp-1-5:.75rem; --sp-2:1rem; --sp-3:1.5rem; --sp-4:2rem; --sp-6:3rem;
  --radius:.25rem; --radius-lg:.5rem;
  --shadow-1:0 1px 2px rgba(26,34,51,.08);

  --font:Roboto,"Segoe UI","Helvetica Neue",Arial,sans-serif;
  --h1:1.75rem; --h2:1.125rem; --h3:1rem; --body1:1rem; --body2:.875rem; --caption:.75rem;

  box-sizing:border-box;
  min-height:100vh;
  padding-top:env(safe-area-inset-top,0px); padding-bottom:env(safe-area-inset-bottom,0px);
  background:var(--bg-default);color:var(--text-primary);
  font-family:var(--font);font-size:var(--body1);line-height:1.5;
}
.root *,.root *::before,.root *::after{box-sizing:inherit}
.root h1,.root h2,.root h3,.root p{margin:0}
.h1{font-size:var(--h1);font-weight:600;line-height:1.2}
.title{color:#009BDE}
.h2{font-size:var(--h2);font-weight:600}
.h3{font-size:var(--h3);font-weight:600}
.body2{font-size:var(--body2)}
.caption{font-size:var(--caption)}
.muted{color:var(--text-secondary)}
.srOnly{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0}
.root :focus-visible{outline:3px solid var(--secondary-main);outline-offset:2px}
.root a{color:var(--primary-main);text-decoration:underline}

.skip{position:absolute;left:var(--sp-2);top:-3rem;background:var(--primary-main);color:#fff;padding:var(--sp-1) var(--sp-2);border-radius:var(--radius);z-index:10}
.root .skip{color:#fff}
.skip:focus{top:var(--sp-2)}

.wrap{max-width:90rem;margin:0 auto;padding:var(--sp-4) var(--sp-3) var(--sp-6)}
.root header{display:flex;flex-direction:column;gap:var(--sp-1);margin-bottom:var(--sp-3)}
.brand{display:flex;align-items:center;gap:var(--sp-2)}
.logo{display:block;flex:none;height:3.5rem;width:auto}
.brandText{display:flex;flex-direction:column;min-width:0}
.conf{align-self:flex-start;border:1px solid var(--grey-300);border-radius:var(--radius);padding:0 var(--sp-1);background:var(--bg-paper)}

/* Environment picker */
.root fieldset.env{border:0;margin:0 0 var(--sp-3);padding:0;min-width:0}
.root fieldset.env legend{padding:0;margin-bottom:var(--sp-1)}
.envOpts{display:grid;grid-template-columns:repeat(auto-fit,minmax(13rem,1fr));gap:var(--sp-1-5)}
.opt{display:grid;grid-template-columns:auto 1fr;column-gap:var(--sp-1-5);align-items:start;padding:var(--sp-1-5) var(--sp-2);border:1px solid var(--grey-300);border-radius:var(--radius-lg);background:var(--bg-paper);cursor:pointer}
.root .opt input{margin:.2rem 0 0;width:1.1rem;height:1.1rem;accent-color:var(--primary-main)}
.opt .t{font-weight:600}
.opt .d{grid-column:2}
.opt:has(input:checked){border-width:2px;padding:calc(var(--sp-1-5) - 1px) calc(var(--sp-2) - 1px)}
.opt.prod .t{color:var(--success-dark)} .opt.prod:has(input:checked){border-color:var(--success-dark);background:var(--success-light-10)}
.opt.uat  .t{color:var(--warning-dark)} .opt.uat:has(input:checked){border-color:var(--warning-dark);background:var(--warning-light-10)}
.opt.dev  .t{color:var(--grey-700)}     .opt.dev:has(input:checked){border-color:var(--grey-700);background:var(--grey-100)}
.opt.all  .t{color:var(--primary-main)} .opt.all:has(input:checked){border-color:var(--primary-main);background:var(--primary-light-10)}
.opt:has(input:focus-visible){outline:3px solid var(--secondary-main);outline-offset:2px}

.help{background:var(--primary-main);color:#fff;border-radius:var(--radius-lg);padding:var(--sp-2) var(--sp-3);margin-bottom:var(--sp-3)}
.root .help a{color:#fff;font-weight:600}
.help ul{list-style:none;margin:var(--sp-1) 0 0;padding:0;display:grid;grid-template-columns:repeat(auto-fit,minmax(16rem,1fr));gap:var(--sp-1) var(--sp-3)}
.help .tbc{font-style:italic;color:var(--primary-light-30)}

.filters{display:flex;flex-wrap:wrap;gap:var(--sp-2);align-items:flex-end;margin-bottom:var(--sp-1-5)}
.field{display:flex;flex-direction:column;gap:.25rem;flex:1 1 18rem}
.root .field input{font:inherit;padding:var(--sp-1) var(--sp-1-5);border:1px solid var(--grey-500);border-radius:var(--radius);background:var(--bg-paper);color:var(--text-primary)}
.check{display:flex;gap:var(--sp-1);align-items:center;padding-bottom:var(--sp-1)}
.root .check input{width:1.1rem;height:1.1rem;accent-color:var(--primary-main)}
.chips{display:flex;flex-wrap:wrap;gap:var(--sp-1);margin-bottom:var(--sp-2)}
.root .chip{font:inherit;font-size:var(--body2);padding:.3rem var(--sp-1-5);border-radius:1rem;border:1px solid var(--grey-300);background:var(--bg-paper);color:var(--text-primary);cursor:pointer}
.root .chip[aria-pressed="true"]{background:var(--primary-main);border-color:var(--primary-main);color:#fff}
.chip[aria-pressed="true"]::before{content:"✓ "}

.count{margin-bottom:var(--sp-1-5)}
.grid{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:repeat(auto-fill,minmax(18rem,1fr));gap:var(--sp-1-5)}
.card{background:var(--bg-paper);border:1px solid var(--grey-300);border-radius:var(--radius-lg);box-shadow:var(--shadow-1);padding:var(--sp-2);display:flex;flex-direction:column;gap:var(--sp-1-5);height:100%}
.cardTop{display:flex;justify-content:space-between;gap:var(--sp-1);align-items:flex-start}
.cat{color:var(--primary-main);font-weight:600}
.badge{font-size:var(--caption);border:1px solid var(--grey-300);border-radius:var(--radius);padding:0 var(--sp-1);color:var(--text-secondary);white-space:nowrap}
.badge.legacy{border-color:var(--warning-dark);color:var(--warning-dark)}
.card.legacy{background:var(--grey-100)}

.root .btn{display:block;text-align:center;text-decoration:none;font-weight:600;font-size:var(--body2);padding:var(--sp-1);border-radius:var(--radius);border:1.5px solid}
.root .btn.prod{color:var(--success-dark);border-color:var(--success-dark);background:var(--success-light-10)}
.root .btn.uat {color:var(--warning-dark);border-color:var(--warning-dark);background:var(--warning-light-10)}
.root .btn.dev {color:var(--grey-700);border-color:var(--grey-700);background:var(--bg-paper)}
.root .btn:hover{text-decoration:underline}
.root .btn.none{border:1.5px dashed var(--grey-500);color:var(--text-secondary);background:transparent;font-weight:400}
.btns{display:grid;grid-template-columns:repeat(3,1fr);gap:var(--sp-1)}
.btns .btn{padding:var(--sp-1) .25rem}
.cardFoot{margin-top:auto;display:flex;justify-content:space-between;gap:var(--sp-1);border-top:1px solid var(--grey-300);padding-top:var(--sp-1)}
.root .cardFoot a{font-weight:600}

/* empty / loading / error states */
.state{background:var(--bg-paper);border:1px dashed var(--grey-500);border-radius:var(--radius-lg);padding:var(--sp-4) var(--sp-3);text-align:center;display:flex;flex-direction:column;gap:var(--sp-1);align-items:center}
.state.error{border-style:solid;border-color:var(--warning-dark)}
.root .state button{font:inherit;font-weight:600;padding:var(--sp-1) var(--sp-2);border-radius:var(--radius);border:1px solid var(--primary-main);background:var(--primary-main);color:#fff;cursor:pointer;margin-top:var(--sp-1)}
.root footer{margin-top:var(--sp-4)}
